module.exports = __webpack_public_path__ + "static/Executive Coach - Angela Cooney - EMCC -accredited coach-5c5e1a648d7942daae8e6b0c8b6575a9.svg";